<template>
    <section class="page__contact marquee__holder background-image-holder" v-if="result" id="content">

        <div class="small-wrapper">

            <intro-component :intro="result.contact.data.attributes.intro.Intro"
                            :isContactPage="true"
                            :isCover="true"
                            :subtitle= "result.contact.data.attributes.subtitle"
                            :isAnimated="true"
            ></intro-component>

            <contact-form 
                type="project"
                gsap-animation="fadeIn"
                gsap-delay="0.3"
                gsap-duration="0.2"
                gsap-ease="none">
            </contact-form>

        </div>

        <div class="marquee">
            Work with us/Work with us/Work with us/Work with us/Work with us/Work with us/Work with us/Work with us/Work with us/
        </div>

        <!-- <span class="contact-shape1"></span>
        <span class="contact-shape2"></span>
        <span class="contact-shape3"><contact-quitar/></span>
        <span class="contact-square"><contact-squares/></span>
        <span class="contact-shape4"></span> -->
        <span class="contact-noise"></span>

        <span class="contact-background">
            <!-- <connect-background/> -->
        </span>

        <Seo :seoData="result.contact.data.attributes.seo"/>

    </section>
</template>

<script lang="ts">

    import { defineComponent, ref } from 'vue'
    import gql from 'graphql-tag'
    import axios from 'axios'

    import ContactForm from '../components/ContactForm.vue';

    import { useQuery } from '@vue/apollo-composable'
    import { CONTACT_QUERY } from '../graphql/contact'

    import IntroComponent from '../components/IntroComponent.vue'
    import ContactSquares          from "../components/svg/ContactSquares.vue"
    import ContactQuitar          from "../components/svg/ContactQuitar.vue"
    import ConnectBackground from "../components/svg/ConnectBackground.vue"

    import Seo from '../components/navigation/Seo.vue'

    export default defineComponent({
        components: {
            IntroComponent,
            ContactForm,
            ContactSquares,
            ContactQuitar,
            ConnectBackground,
            Seo,
        },
        setup() {
            const contact_query = ref(CONTACT_QUERY)
            const { result } = useQuery(contact_query)

            return {
                result
            }
        }
    })
</script>
